module.exports = __webpack_public_path__ + "img/utilitylight_parked.390188a1.svg";